import React from 'react'
import { ProgressBar } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { t } from '../../../../i18n'


interface CashbackUserLevelProps {
    nextLevelPercentage?: number
}


export default function CashbackUserLevel({ nextLevelPercentage }: CashbackUserLevelProps): React.ReactElement {
    return (
        <div data-testid="userlevel">
            <div className="verify-account pb-1">
                <Link to={"/account/vip-level"}>{t("cashback.cashbackButton.userLevelLink")}</Link> {t("cashback.cashbackButton.userLevelText")}
            </div>
           {nextLevelPercentage && nextLevelPercentage > 0 &&  <ProgressBar now={nextLevelPercentage} label={`${nextLevelPercentage}%`} style={{ borderRadius: "4px", height: "20px" }} />}
        </div>
    )
}
